export const MODAL_ROW_CLASSNAME = 'c-ModalRow';

export const CLASSNAME_BY_PROP = {
  'shouldBeCenteredHorizontally': 'centered-horizontally',
  'shouldBeSpaceBetween': 'space-between',
  'shouldBoundToBottom': 'bound-to-bottom',
};
